import { Box } from '@chakra-ui/react';

export default function PlusPeople(props) {
  return (
    <Box {...props}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.9999 9.58325C16.3832 9.58325 17.4915 8.46659 17.4915 7.08325C17.4915 5.69992 16.3832 4.58325 14.9999 4.58325C14.7332 4.58325 14.4749 4.62492 14.2415 4.69992C14.7165 5.37492 14.9915 6.19159 14.9915 7.08325C14.9915 7.97492 14.7082 8.78325 14.2415 9.46659C14.4749 9.54159 14.7332 9.58325 14.9999 9.58325ZM5.83333 8.74992H4.16667V7.08325C4.16667 6.62492 3.79167 6.24992 3.33333 6.24992C2.875 6.24992 2.5 6.62492 2.5 7.08325V8.74992H0.833333C0.375 8.74992 0 9.12492 0 9.58325C0 10.0416 0.375 10.4166 0.833333 10.4166H2.5V12.0833C2.5 12.5416 2.875 12.9166 3.33333 12.9166C3.79167 12.9166 4.16667 12.5416 4.16667 12.0833V10.4166H5.83333C6.29167 10.4166 6.66667 10.0416 6.66667 9.58325C6.66667 9.12492 6.29167 8.74992 5.83333 8.74992ZM13.325 7.08325C13.325 8.46659 12.2167 9.58325 10.8333 9.58325C9.45 9.58325 8.33333 8.46659 8.33333 7.08325C8.33333 5.69992 9.45 4.58325 10.8333 4.58325C12.2167 4.58325 13.325 5.69992 13.325 7.08325ZM10.8333 11.2499C9.16667 11.2499 5.83333 12.0833 5.83333 13.7499V14.5833C5.83333 15.0416 6.20833 15.4166 6.66667 15.4166H15C15.4583 15.4166 15.8333 15.0416 15.8333 14.5833V13.7499C15.8333 12.0833 12.5 11.2499 10.8333 11.2499ZM17.5001 13.7499C17.5001 12.7666 17.0418 11.9916 16.3501 11.3833C18.0251 11.6749 20.0001 12.4666 20.0001 13.7499V14.9999C20.0001 15.2333 19.8168 15.4166 19.5834 15.4166H17.4584C17.4834 15.2833 17.5001 15.1416 17.5001 14.9999V13.7499Z"
          fill="currentColor"
        />
      </svg>
    </Box>
  );
}
